import { z } from 'zod';
/** Statut d'une facture Pennylane — `03` §2 (`pennylaneInvoices.status`) et §3. */
export const PENNYLANE_INVOICE_STATUSES = ['pending', 'sent', 'queued', 'ignored', 'error'];
export const pennylaneInvoiceStatusSchema = z.enum(PENNYLANE_INVOICE_STATUSES);
export const PENNYLANE_INVOICE_STATUS = {
    pending: {
        code: 'pending',
        label: 'À transmettre',
        tone: 'gray',
        description: 'Sélectionnée, pas encore traitée par un run.',
    },
    sent: {
        code: 'sent',
        label: 'Transmise',
        tone: 'blue',
        description: 'CSV déposé sur le FTP Martelet (compte 216).',
    },
    queued: {
        code: 'queued',
        label: 'À transmettre',
        tone: 'gray',
        description: 'CSV produit, envoi différé car les envois vers Martelet sont suspendus.',
    },
    ignored: {
        code: 'ignored',
        label: 'Ignorée',
        tone: 'gray',
        description: 'Exclue volontairement (historique, « Import auto » ≠ oui, sans ligne produit).',
    },
    error: {
        code: 'error',
        label: 'En erreur',
        tone: 'red',
        description: 'Facture incomplète ou envoi en échec ; jamais envoyée partiellement.',
    },
};
//# sourceMappingURL=pennylane.js.map